import { render, staticRenderFns } from "./userStampUpdateLogDetail.vue?vue&type=template&id=530ce8b4"
import script from "./userStampUpdateLogDetail.vue?vue&type=script&lang=js"
export * from "./userStampUpdateLogDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports